import FilterModal from "src/components/common/FilterFrame/FilterModal";
import type { FilterFieldConfig } from "src/components/common/FilterFrame/FilterModal";

export const fields: FilterFieldConfig[] = [
    { key: "name",           label: "Name",            type: "text", default: "" }, // combine firstName, middleName, lastName
    { key: "email",          label: "Email",           type: "text", default: "" },
    { key: "region",         label: "Region",          type: "text", default: "" },
    { key: "department",     label: "Department",      type: "text", default: "" },
    { key: "role",           label: "Role",            type: "text", default: "" },
    { key: "phoneNumber",    label: "Mobile Number",   type: "text", default: "" },
    { key: "workphone",      label: "Work Phone",      type: "text", default: "" },
    { key: "extension",      label: "Extension",       type: "text", default: "" },
    { key: "driverLicense",  label: "Driver License",  type: "text", default: "" },
    { key: "ssn",            label: "SSN",             type: "text", default: "" },
    { key: "birthDay",       label: "Birthday",        type: "range", default: "", inputType: "date"},
    { key: "hireDate",       label: "Hire Date",       type: "range", default: "", inputType: "date" },
    { key: "quitDate",       label: "Quit Date",       type: "range", default: "", inputType: "date" },
    { key: "phaseLevel",     label: "Phase Level",     type: "text", default: "" },
    { key: "unionName",      label: "Union Name",      type: "text", default: "" },
    { key: "invoiceNumber",  label: "Invoice Number",  type: "text", default: "" },
    { key: "lanId",          label: "Lan Id",          type: "text", default: "" },
    { key: "residence",      label: "Residence",       type: "text", default: "" },
    { key: "residenceState", label: "Residence State", type: "text", default: "" },
    { key: "street",         label: "Street",          type: "text", default: "" },
    { key: "zipCode",        label: "Zip Code",        type: "text", default: "" },
    { key: "address",        label: "Address",         type: "text", default: "" },
    { key: "background",     label: "Background",      type: "text", default: "" },
    { key: "projects",       label: "Projects",       type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "edit", label: "Edit"}, 
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
    ] },
    { key: "assignments",       label: "Assignments",      type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "yes", label: "Yes"}, 
        {value: "no", label: "No"}
    ] },
    { key: "purchases",      label: "Purchases",      type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "approver", label: "Approver"}, 
        {value: "paid", label: "Paid"}, 
        {value: "edit", label: "Edit"},  
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
    ] },
    { key: "perDiem",        label: "Per Diem",       type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "editAll", label: "Edit All"}, 
        {value: "edit", label: "Edit"},  
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
    ] },
    { key: "reports",        label: "Reports",        type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "editAll", label: "Edit All"}, 
        {value: "edit", label: "Edit"},  
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
    ] },
    { key: "forms",          label: "Forms",          type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "editAll", label: "Edit All"}, 
        {value: "edit", label: "Edit"},  
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
    ] },
    { key: "personel",       label: "Personnel",      type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "edit", label: "Edit"},  
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
    ] },
    { key: "fleets",         label: "Fleets",         type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "edit", label: "Edit"},  
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
    ] },
    { key: "calendar",       label: "Calendar",       type: "select", default: "", options: [ 
        {value: "", label: "Select"}, 
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
    ] },
    { key: "timeOffs",       label: "Time Offs",      type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "approver", label: "Approver"}, 
        {value: "editAll", label: "Edit All"}, 
        {value: "edit", label: "Edit"},  
        {value: "viewAll", label: "View All"}, 
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
    ] },
    { key: "office",         label: "Office",         type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "yes", label: "Yes"}, 
        {value: "no", label: "No"}
    ] },
    { key: "allOffice",      label: "All Office",     type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "edit", label: "Edit"},  
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
    ] },
    { key: "outside",        label: "Outside",        type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "locator", label: "Locator"}, 
        {value: "standby", label: "Stand By"}, 
        {value: "qew", label: "QEW"},  
        {value: "runner", label: "Runner"}, 
        {value: "no", label: "No"}
    ] },
    { key: "outsideStatus",  label: "Outside Status", type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "edit", label: "Edit"},  
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
    ] },
    { key: "metrics",        label: "Metrics", type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "all", label: "All"}, 
        {value: "yes", label: "Yes"}, 
        {value: "no", label: "No"}
    ] }, 
    { key: "newspaper",      label: "Newspaper",      type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "edit", label: "Edit"},  
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
    ] },
    { key: "community",      label: "Community", type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "editAll", label: "Edit All"}, 
        {value: "edit", label: "Edit"},  
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
    ] }, 
    { key: "trainings",      label: "Trainings", type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "edit", label: "Edit"},  
        {value: "view", label: "View"}, 
        {value: "no", label: "No"}
    ] }, 
    { key: "assignmentNotification", label: "Assignment Notification", type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "yes", label: "Yes"}, 
        {value: "no", label: "No"}
    ] }, 
    { key: "dispatch",       label: "Dispatch", type: "select", default: "", options: [
        {value: "", label: "Select"}, 
        {value: "yes", label: "Yes"}, 
        {value: "no", label: "No"}
    ] }, 
    { key: "creatorId", label: "Created By", type: "asyncSelect", default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search User",
        isMulti: false,
    },
    { key: "createdAt", label: "Created At", type: "range", default: "", inputType: "date" },
    { key: "updaterId", label: "Updated By", type: "asyncSelect", default: "", 
        fileName: "common/searchUser.php", 
        placeholder: "Search User", 
        isMulti: false, 
    },
    { key: "updatedAt", label: "Updated At", type: "range", default: "", inputType: "date" },
    { key: "void", label: "Validity", type: "select", default: "no",
        options: [
        { value: "no", label: "Valid" },
        { value: "yes", label: "Void" },
        { value: "all", label: "All" },
        ],
    },
    { key: "voidReason", label: "Void Reason", type: "text", default: "" },
    { key: "validateReason", label: "Validate Reason", type: "text", default: "" },
];

export default function UsersFilterForm() {
    return <FilterModal title="Filter" width={650} fields={fields} />;
}
